// extracted by mini-css-extract-plugin
export default {"mainContainer":"Trademark_mainContainer__14cuy","intro":"Trademark_intro__6Z+Ac","title":"Trademark_title__Ewm7D","description":"Trademark_description__cDPgg"};